module.exports = __webpack_public_path__ + "static/img/0545_8.6e402ce.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/home/img/0545_8.jpg
// module id = ghsk
// module chunks = 1